import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/lawsAndRegulations';

export default function LawsAndRegulations() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Most of exam section 2.4 is the Uniform Securities Act, the Investment Advisers Act of 1940, and the NASAA Model Rules themselves — read those directly in the cards below. This page fills in what's left: definitions from other federal acts, Form ADV and Form U4 in practice, a few named SEC/MSRB rules, and the Uniform Prudent Investor Act."
      parts={parts}
    />
  );
}
